<template >
    <v-app class="bg-surface">
    <div class="scaled-app">
      <v-layout class="scaled">
      <v-app-bar
        v-if="noDisplayRoutes"
        :flat="true" class="scaled-bar"
      >
        <v-app-bar-title class="ms-2" style="z-index: 999">
          <Logo :responsive="true" @click="changeHover"/>
        </v-app-bar-title>
        <v-menu>
          <template #activator="{ props }">
            <v-btn icon="mdi-account" v-bind="props" class="bg-background rounded-xl" />
          </template>
          <v-list bg-color="surface" class="rounded-xl" elevation="0">
            <v-list-item
              prepend-icon="mdi-folder-account" title="Cuenta"
              @click="navigateTo('/my-account')" />
            <v-list-item
              prepend-icon="mdi-file-link" title="Configuración"
              @click="navigateTo('/configuration')" />
            <v-list-item
              prepend-icon="mdi mdi-lock" title="Contraseña"
              @click="navigateTo('/my-password')" />
            <v-list-item
              v-if="storePermissions.getIsAdmin" prepend-icon="mdi-badge-account"
              title="Roles y permisos" @click="navigateTo('/permissions')" />
            <v-list-item
              prepend-icon="mdi-theme-light-dark" title="Cambiar tema"
              @click="toggleTheme" />
            <v-list-item
              prepend-icon="mdi-exit-to-app" title="Salir"
              @click="logout" />
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-navigation-drawer
        v-if="noDisplayRoutes"
        expand-on-hover
        :rail="true"
        border="0"
        class="scaled-drawer rounded-e-xl"
        width="350"
        :permanent="hover"
      >
        <v-list density="compact" :nav="true">
          <v-list-group
            :key="storeSession.getCurrentRFC" :value="storeSession.getCurrentRFC"
            :title="storeSession.getCurrentRFC" prepend-icon="mdi-key">
            <template #activator="{ props }">
              <v-list-item
                v-bind="props" :title="storeSession.getCurrentRFC" rounded="xl"
                subtitle="RFC">
                <template #append>
                  <v-chip color="success" variant="elevated" density="compact" elevation="0" text="ACTIVO"/>
                </template>
              </v-list-item>
            </template>
            <v-list-item
              v-for="(item, index) in storeSession.getAllRfcs" :key="index" prepend-icon="mdi-key"
              rounded="xl" subtitle="RFC"
              :title="item.rfc" @click="selectRFC(item.rfc)">
              <template v-if="storeSession.getCurrentRFC===item.rfc" #append>
                <v-badge color="success" inline dot />
              </template>
            </v-list-item>
          </v-list-group>
        </v-list>
        <v-divider />

        <v-list>
          <v-list-group
            v-for="(item, i) in storePermissions.getDrawerPaths" :key="i" :value="item.title"
            :prepend-icon="item.icon">
            <template #activator="{ props }">
              <v-list-item v-bind="props" :title="item.title" rounded="xl" />
            </template>
            <template v-for="(subitem, j) in item.items">
              <v-list-item
                v-if="!subitem.items"
                :key="j"
                rounded="xl"
                :prepend-icon="subitem.icon" :title="subitem.text" :value="subitem.link"
                @click="navigateTo(subitem?.link)"
              />
              <template v-else>
                <v-list-group
                  :key="j" :value="subitem.text"
                  :prepend-icon="subitem.icon"
                >
                  <template #activator="{ props }">
                    <v-list-item v-bind="props" :title="subitem.text" rounded="xl" />
                  </template>
                  <v-list-item
                    v-for="(subsubitem) in subitem.items" :key="subsubitem.link" rounded="xl"
                    :prepend-icon="subsubitem.icon" :title="subsubitem.text"
                    :value="subsubitem.link"
                    @click="navigateTo(subsubitem?.link)" />
                </v-list-group>
              </template>
            </template>
          </v-list-group>
        </v-list>
        <template #append>
          <v-list>
            <v-list-item
              prepend-icon="mdi-help-circle-outline" title="Ayuda" tag="a"
              href="https://verifica-t.com/contacto" target="_blank" />
            <v-list-item
              prepend-icon="mdi-scale-balance" title="Términos y condiciones" tag="a"
              href="https://verifica-t.com/terminos-y-condiciones" target="_blank" />
            <v-list-item
              prepend-icon="mdi-star"
              :title="`Verifica-t v2.0 ${new Date().getFullYear() }`" />
          </v-list>
        </template>
      </v-navigation-drawer>

      <v-main>
        <v-sheet class="fill-height bg-background rounded-t-xl">
          <v-breadcrumbs
            v-if="noDisplayRoutes" :items="breadcrumbs"
            class="text-caption ma-0 pa-0 px-5 pt-2" />

          <v-container fluid>
            <v-overlay
              v-model="storeAppOptions.getLoading"
              class="align-center justify-center"
              persistent>
              <v-row justify="center">
                <v-progress-circular indeterminate :size="80" :width="8" color="primary" />
              </v-row>
              <v-row justify="center">
                <h5 style="background-color: rgba(130,130,130,0.72); padding: 8px; border-radius: 10px;" class="mt-3">{{storeAppOptions.loadingText}}{{dots}}</h5>
              </v-row>
            </v-overlay>

            <v-alert
              v-model="storeAppOptions.flag" :text="storeAppOptions.getSnack"
              :title="storeAppOptions.getTitle" :type="storeAppOptions.getType"
              class="mb-3" variant="tonal" position="relative"
              rounded="xl" closable
            />

            <v-snackbar
              v-model="storeAppOptions.globalSnack"
              variant="elevated"
              rounded="pill"
              width="700"
              :color="storeAppOptions.globalSnackColor"
              :timeout="8000"
              class="pa-4"
            >
              <p :class="`${storeAppOptions.globalSnackColorButton} ml-5 font-weight-bold`">{{storeAppOptions.globalSnackTitleText}}</p>
              <p v-if="typeof formattedMsg === 'string'" :class="`${storeAppOptions.globalSnackColorButton} ml-5`">{{formattedMsg}}</p>
              <p v-else v-for="(error, index) in formattedMsg" :key="index" :class="`${storeAppOptions.globalSnackColorButton} ml-5`">
                • {{ error }}
              </p>

              <template v-slot:actions>
                <v-btn
                  rounded="pill"
                  variant="text"
                  @click="storeAppOptions.setGlobalSnack(false, storeAppOptions.globalSnackText, storeAppOptions.globalSnackColor, storeAppOptions.globalSnackColorButton)"
                >
                  <p :class="storeAppOptions.globalSnackColorButton">Cerrar</p>
                </v-btn>
              </template>
            </v-snackbar>

            <router-view />
          </v-container>
        </v-sheet>
      </v-main>
    </v-layout>
    </div>
  </v-app>
</template>
<script>
import Logo from '@/components/ui/Logo.vue'
import { sessionUserStore } from '@/store/session-store/session'
import { permissionsUserStore } from '@/store/permissions-store/permissions'
import { noDisplayRoutes } from '@/plugins/router'
import { appOptionsStore } from '@/store/app-options-store/appOptionsStore'
import {createLogbookEntry} from "./services/auth";

export default {
  components: {
    Logo,
  },
  data(){
    return {
      hover:false,
      dots: '',
      intervalId: null
    }
  },
  computed: {
    storeSession() {
      return sessionUserStore()
    },
    storePermissions() {
      return permissionsUserStore()
    },
    storeAppOptions() {
      return appOptionsStore()
    },
    noDisplayRoutes() {
      return !noDisplayRoutes.has(this.$route.path)
    },
    breadcrumbs() {
      let pathArray = this.$route.path.split('/')
      pathArray.shift()
      return pathArray.reduce((breadcrumbArray, path, idx) => {
        breadcrumbArray.push(this.$route.matched[idx] ? this.$route.matched[idx].meta.breadcrumb || path : '')
        return breadcrumbArray
      }, [])
    },
    breakPoint() {
      return this.$vuetify.display.smAndDown;
    },
    formattedMsg(){
      if (this.storeAppOptions.globalSnackText.includes(',')){
        return this.storeAppOptions.globalSnackText.split(', ');
      }else{
        return this.storeAppOptions.globalSnackText;
      }
    }
  },
  methods: {
    selectRFC(rfc) {
      this.storeSession.selectCurrentRFC(rfc);
      location.reload();
    },
    navigateTo(routeLink) {
      this.$router.push(routeLink);
    },
    async logout() {
      await createLogbookEntry({
        action_name: 'LOGOUT',
        email: this.storeSession.getUserData.email
      });
      sessionStorage.clear()
      location.reload()
    },
    toggleTheme() {
      this.$vuetify.theme.global.name = this.$vuetify.theme.current.dark ? 'LIGHT' : 'DARK'
    },
    changeHover() {
      if (this.breakPoint) {
        this.hover = !this.hover;
      }
    },
    startAnimation(){
      let count = 0;
      this.intervalId = setInterval(() => {
        count = (count + 1) % 4;
        this.dots = '.'.repeat(count);
      }, 300);
    },
    stopAnimation(){
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  },
  watch:{
    'storeAppOptions.getLoading':function (current){
      if (current){
        this.startAnimation();
      }else{
        this.stopAnimation();
      }
    }
  }
}
</script>


<style scoped>
.scaled-app {
  transform: scale(0.90);
  transform-origin: left;
  width: 111.5%;
  height: 0.5vh;
}
.scaled{
  min-height: 120vh;
}
</style>
